import auth from "./auth";
import {createRouter, createWebHashHistory} from "vue-router";

import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";

import appConfig from "@/utils/app-config";
import {locale, loadMessages} from "devextreme/localization";
import deMessages from 'devextreme/localization/messages/de.json';
import enMessages from 'devextreme/localization/messages/en.json';
import appMessages from '@/app-translation.json';

import menu from "./app-navigation.json";
import mobileMenu from "./app-navigation-mobile.json";

function loadView(view) {
    return () => import (/* webpackChunkName: "login" */ `./views/${view}.vue`)
}

function addRouteFromMenuItem(items) {
    if (items)
        items.forEach((item) => {
            if (item.path && item.path !== '') {
                router.addRoute({
                    component: loadView(item.path.replace('/', '')),
                    name: item.name || item.path.replace('/', ''),
                    path: item.path,
                    meta: {
                        requiresAuth: true,
                        layout: defaultLayout,
                    }
                });
            }
            if (item.items) addRouteFromMenuItem(item.items);
        });
}

appConfig.language = localStorage.getItem('language');
if (!appConfig.language || appConfig.language === '') {
    appConfig.language = 'de';
    localStorage.setItem('language', appConfig.language);
}
switch (appConfig.language) {
    case 'de':
        loadMessages(deMessages);
        break;
    default:
        loadMessages(enMessages);
}

locale(appConfig.language);
loadMessages(appMessages);

const version = localStorage.getItem('version');
const sessionToken = localStorage.getItem('sessionToken')
appConfig.rememberMe = sessionToken !== null;

if (version !== appConfig.version) {
    localStorage.clear();
    localStorage.setItem('sessionToken', sessionToken);
    localStorage.setItem('version', appConfig.version);
}

const router = new createRouter({
    routes: [
        {
            path: "/home",
            name: "home",
            meta: {
                requiresAuth: true,
                layout: defaultLayout
            },
            component: loadView("home-page")
        },
        {
            path: "/login-form",
            name: "login-form",
            meta: {
                requiresAuth: false,
                layout: simpleLayout,
            },
            component: loadView("login-form")
        },
        {
            path: "/",
            redirect: "/home"
        },
        {
            path: "/recovery",
            redirect: "/home"
        },
        {
            path: "/:pathMatch(.*)*",
            redirect: "/home"
        }
    ],
    history: createWebHashHistory()
});

await auth.authenticate();

if (appConfig.isMobile)
    appConfig.menu = mobileMenu;
else
    appConfig.menu = menu;

if (appConfig.menu)
    addRouteFromMenuItem(appConfig.menu);

router.beforeEach((to, from, next) => {

    if (from.name === 'login-form' && auth.loggedIn()) {
        if (appConfig.isMobile)
            appConfig.menu = mobileMenu;
        else
            appConfig.menu = menu;

        if (appConfig.menu)
            addRouteFromMenuItem(appConfig.menu);
    }


    if (to.name === "login-form" && auth.loggedIn()) {
        next({name: "home"});
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!auth.loggedIn()) {
            next({
                name: "login-form",
                query: {redirect: to.fullPath}
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
